import { action, observable } from "mobx";

import { ClaimStatuses } from "@libs/gateways/acc/AccGateway.dtos.ts";
import type { IRootStore } from "@shared-types/root/root-store.interface.ts";

export class ChangeConditionHelper {
  constructor(private root: IRootStore) {}

  @observable
  showChangeConditionSecondColumn: boolean = false;

  @action
  setShowChangeConditionSecondColumn = (val: boolean) => {
    this.showChangeConditionSecondColumn = val;
  };

  @observable
  showChangeConditionDialog: boolean = false;

  @action
  setShowChangeConditionDialog = (val: boolean) => {
    this.showChangeConditionDialog = val;
  };

  @action
  checkClaimStatus = async (claimId: string) => {
    if (claimId) {
      const claim = await this.root.acc.getClaim(claimId);

      if (
        claim.claimStatus === ClaimStatuses.Incomplete ||
        claim.claimStatus === ClaimStatuses.Queued ||
        claim.claimStatus === ClaimStatuses.Pending ||
        claim.claimStatus === ClaimStatuses.Accredited ||
        claim.claimStatus === ClaimStatuses.Accepted ||
        claim.claimStatus === ClaimStatuses.Held ||
        claim.claimStatus === ClaimStatuses.NotVerified
      ) {
        return true;
      }

      if (
        claim.claimStatus === ClaimStatuses.Declined ||
        claim.claimStatus === ClaimStatuses.Error ||
        claim.claimStatus === ClaimStatuses.NotAvailable
      ) {
        return false;
      }
    }
    return true;
  };
}
